import React from 'react';
import styles from './TasksContainer.module.css';
import { TaskCard } from './TaskCard';
import { TaskCardType } from '../../types';

interface TasksContainerProps {
  tasks: TaskCardType[];
  onModalShow: () => void;
}

export const TasksContainer: React.FC<TasksContainerProps> = ({ tasks, onModalShow }) => {
  if (tasks.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Задания</h3>
      <div className={styles.cards}>
        {tasks.map((task: TaskCardType) => (
          <TaskCard 
            key={task.id} 
            task={task} 
            onModalShow={onModalShow}
          />
        ))}
      </div>
    </div>
  );
};
